import React, { Component } from 'react';
import { Text, View, ScrollView, Switch, Image, StyleSheet } from 'react-native';

import { I18n, DatePicker, Utils, SelectionList, OPComponent } from '../components';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';
import { getUIRepeatValues } from './event_UI_helpers';

import { convertDateFromTZ, convertDateToTZ } from './timezone_helper';
import momentTz from 'moment-timezone';

export default class SelectRepeat extends OPComponent {
  constructor(props) {
    super(props);

    let repeatValues = getUIRepeatValues();
    let tz = props.timeZone || 'America/Los_Angeles';

    let convertedEnd = props.endDate && convertDateFromTZ(props.endDate, tz);
    let convertedMin =
      (props.minimumDate && convertDateFromTZ(props.minimumDate, tz)) || new Date();

    this.state = {
      // items: [{label: 'None', id: null}].concat(Object.keys(repeatValues).map((repeatId) => {
      //   return {label: repeatValues[repeatId], id: repeatId}
      // }))
      items: repeatValues,
      repeatShouldEnd: props.endDate !== null,
      minimumDate: convertedMin,
      selectedId: props.selectedRepeat || 0,
      selectedDate: convertedEnd || convertedMin,
      timeZone: tz,
    };
  }

  componentDidMount() {
    Utils.trackScreen('Calendar', 'Repeat Sheet');
  }

  _returnRepeatEndDate(endDate) {
    if (endDate) {
      endDate = convertDateToTZ(endDate, this.state.timeZone);
      let endMoment = momentTz.tz(endDate.toISOString(), this.state.timeZone).endOf('day');
      endDate = endMoment.toDate();
    }
    this.props.onSelectRepeatEnds && this.props.onSelectRepeatEnds(endDate);
  }

  toggleEndRepeat = repeatShouldEnd => {
    Utils.trackEvent('Action', 'Set', 'Toggle End Repeat', parseFloat(repeatShouldEnd));
    this.setState({ repeatShouldEnd });
    let endDateVal = repeatShouldEnd ? this.state.selectedDate : null;
    this._returnRepeatEndDate(endDateVal);
  };

  handleSelect = selectedId => {
    this.setState({ selectedId });
    Utils.trackEvent('Action', 'Set', 'Repeat', selectedId);
    this.props.onSelectRepeat && this.props.onSelectRepeat(selectedId);
  };

  handleDateSelect = selectedDate => {
    if (this.state.repeatShouldEnd) {
      Utils.trackEvent(
        'Action',
        'Set',
        'End Repeat Date',
        selectedDate.getUTCMilliseconds() / 1000 // Unix timestamp
      );

      this._returnRepeatEndDate(selectedDate);
      this.setState({ selectedDate });
    }
  };

  render() {
    return (
      <View style={styles.containerAlt}>
        <ScrollView alwaysBounceVertical={false} contentContainerStyle={styles.scrollViewContent}>
          <SelectionList
            items={this.state.items}
            selectedId={this.state.selectedId}
            onSelect={this.handleSelect}
          />
          <View style={styles.pickerHeader} />
          <View style={styles.allDayRow}>
            <Image
              style={styles.settingIcon}
              source={require('../../../resources/icon-time.png')}
            />
            <Text style={styles.settingText}>{I18n.t('calendar.endsOn')}</Text>
            <Switch value={this.state.repeatShouldEnd} onValueChange={this.toggleEndRepeat} />
          </View>
          <View
            style={styles.datePickerContainer}
            pointerEvents={this.state.repeatShouldEnd ? 'auto' : 'none'}
          >
            <DatePicker
              selectedDate={this.state.selectedDate}
              onDate={this.handleDateSelect}
              minimumDate={this.state.minimumDate}
              mode="date"
            />
          </View>
        </ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  containerAlt: THEME.containerAlt,
  allDayRow: {
    borderColor: COLOR.accent,
    borderBottomWidth: 2,
    height: 70,
    backgroundColor: COLOR.contrast,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 25,
  },
  settingIcon: {
    width: 20,
    height: 20,
  },
  settingText: {
    flex: 1,
    ...FONT.regular,
    fontSize: FONT_SIZE.large,
    color: COLOR.text,
    marginLeft: 20,
  },
  datePickerContainer: {
    backgroundColor: COLOR.contrast,
  },
  pickerHeader: {
    height: 40,
    justifyContent: 'center',
    paddingHorizontal: 25,
    borderColor: COLOR.accent,
    borderBottomWidth: 2,
  },
});
